import { getIDToken } from "../utils/utils";
import * as config from "../config.js";

export const getPlatformFeatures = async () => {
  // We dispatch requestLogin to kickoff the call to the API
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/platform/features`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
    }
  );

  const results = await response.json();
  console.log("!!! RESULTS: ", results);

  if (results.success) {
    return results.features;
  }

  return null;
};
